
import React from "react";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import BlogCompo from "../components/Blog";
import SEO from "../components/SEO";
import StructuredData from "../components/StructuredData";

const Blog = () => {
  return (

  <>
 <SEO
   title="Blog | Car Rental Tips & News | EZ Car Rentals Melbourne"
   description="Read the latest car rental tips, travel guides, and news from EZ Car Rentals Melbourne. Expert advice on vehicle hire, road trips in Victoria, and car rental best practices in Australia."
   keywords="car rental blog Melbourne, vehicle hire tips Victoria, car rental advice Australia, travel tips Melbourne, road trip guides Victoria, car rental news Australia"
   url="https://ezcarrentals.com.au/blog"
 />
 <StructuredData type="organization" />
 <Navbar />
 <BlogCompo />
 <Footer />
 

 </>
  );
};

export default Blog;
